import React, { useEffect } from 'react';

import { Box, ButtonBase, Grid, Typography } from '@material-ui/core';

import { ReactComponent as RightIcon } from '../../../../assets/img/icon/Right.svg';
import partialIcon from '../../../../assets/img/sinister/robbery/partial_theft.svg';
import totalIcon from '../../../../assets/img/sinister/robbery/total_theft.svg';
// import partialIcon from '../../../../assets/img/partial.png';
// import totalIcon from '../../../../assets/img/total.png';
import SuraCard from '../../../../components/SuraCard';
import {
  incidentRoad,
  original_robbery,
} from '../../../../constants/incidents.constant';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import ComplaintValidation from './ComplaintValidation.component';
import Parts from './Parts.component';

const TypeOfTheft = () => {
  const { nextStep, updateSinisterBody } = useSinisterDataContext();
  const { user } = useAuthDataContext();
  let robbery: { [index: string]: any } = incidentRoad.robbery;
  incidentRoad.robbery = original_robbery.robbery;

  useEffect(() => {
    //TODO: fix this bad assignation
    robbery = incidentRoad.robbery;

    robbery.forEach((element: any, key: any) => {
      if (element?.title === 'Aparición del auto') {
        robbery.splice(key, 1);
      }

      if (element?.title === 'Neumáticos robados') {
        robbery.splice(key, 1);
      }

      if (element?.title === 'Como actuar') {
        robbery.splice(key, 1);
      }
    });

    robbery = robbery.sort((a: any, b: any) => (a.order > b.order ? 1 : -1));
  }, []);

  const steps = {
    partial: [
      {
        title: '¿Qué te robaron?',
        content: <Parts />,
        order: 5,
      },
      // {
      //   title: "Neumáticos robados",
      //   content: <StolenTires />,
      //   order: 3,
      // },
      // {
      //   title: "Daños en mi vehículo",
      //   content: <SelectTypeOfDamage />,
      //   order: 4,
      // },
    ],
    total: [
      {
        title: 'Como actuar',
        content: <ComplaintValidation />,
        order: 2,
      },
    ],
  };

  const selectCard = (typeOfRobbery: string) => {
    let keytodelete = null;
    robbery = incidentRoad.robbery;
    updateSinisterBody({ robbery: { type: typeOfRobbery } });

    dataLayerPush('siniestro_OD_robo', user?.id, {
      fieldName: 'opcion_siniestro_tipo_robo',
      fieldValue: typeOfRobbery === 'total' ? 'si me robaron' : 'No me robaron',
    });

    if (typeOfRobbery === 'partial') {
      if (
        !robbery.find(
          (element: { title: any }) => element.title === '¿Qué te robaron?'
        )
      ) {
        steps.partial.forEach((step) => {
          robbery.push(step);
        });
      } else {
        robbery.forEach((element: any, key: any) => {
          if (element?.title === 'Aparición del auto') {
            robbery.splice(key, 1);
          }
          if (
            element?.title === 'Daños en mi vehículo' ||
            element?.title === 'tipo de daños' ||
            element?.title === 'Como actuar' ||
            element?.title === 'Aparición del auto'
          ) {
            robbery.splice(key, 1);
          }
        });
      }
    }
    if (typeOfRobbery === 'total') {
      robbery.forEach((element: any, key: any) => {
        if (element?.title === 'Neumáticos robados') {
          robbery.splice(key, 1);
        }
      });
      if (
        !robbery.find(
          (element: { title: any }) => element.title === 'Como actuar'
        )
      ) {
        steps.total.forEach((step) => {
          robbery.push(step);
        });
      }
    }

    if (keytodelete) robbery.splice(keytodelete, 1);

    robbery = robbery.sort((a: any, b: any) => (a.order > b.order ? 1 : -1));

    nextStep();
  };

  return (
    <Grid item xs={12} sm={6}>
      <Box>
        <Box my={4}>
          <Typography variant="h6" color="textPrimary">
            ¿Qué tipo de robo sufriste?
          </Typography>
        </Box>
        <Box mr={3} mb={3}>
          <ButtonBase
            style={{ width: '100%' }}
            onClick={() => selectCard('total')}
          >
            <SuraCard style={{ width: '100%' }}>
              <Box
                m={3}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                width={'100%'}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <img src={partialIcon} alt={'total'}></img>
                  </Box>
                  <Box ml={1}>
                    <Typography variant="body1">Robo total</Typography>
                  </Box>
                </Box>
                <Box>
                  <RightIcon></RightIcon>
                </Box>
              </Box>
            </SuraCard>
          </ButtonBase>
        </Box>

        <Box mr={3} mb={3}>
          <ButtonBase
            style={{ width: '100%' }}
            onClick={() => selectCard('partial')}
          >
            <SuraCard style={{ width: '100%' }}>
              <Box
                m={3}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                width={'100%'}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <img src={totalIcon} alt={'partial'}></img>
                  </Box>
                  <Box ml={1}>
                    <Typography variant="body1">Robo parcial</Typography>
                  </Box>
                </Box>
                <Box>
                  <RightIcon></RightIcon>
                </Box>
              </Box>
            </SuraCard>
          </ButtonBase>
        </Box>
      </Box>
    </Grid>
  );
};

export default TypeOfTheft;
